import Base from '../base';

function getCatalog(region) {
  return Base.get(`/integrations/catalog/${region}`);
}

function getIntegration(id) {
  return Base.get(`/integrations/catalog_entry/${id}`);
}

function getConnected(cafe_id) {
  return Base.get(`/integrations/connected/${cafe_id}`);
}

function connectIntegration(cafe_id, integration_id) {
  return Base.post(`/integrations/connect/${cafe_id}/${integration_id}`);
}

function disconnectIntegration(cafe_id, integration_id) {
  return Base.post(`/integrations/disconnect/${cafe_id}/${integration_id}`);
}

function updateIntegrationPage(id, data) {
  return Base.post(`/integrations/catalog/update/${id}`, data);
}

function requestIntegration(cafe_id, integration_name) {
  return Base.post(`/integrations/request`, {
    cafe_id,
    integration_name,
  });
}

export default {
  getCatalog,
  getIntegration,
  getConnected,
  connectIntegration,
  disconnectIntegration,
  updateIntegrationPage,
  requestIntegration,
};
